var $353f1bfca4dc395a$exports = {};
$353f1bfca4dc395a$exports = {
  "decrease": function decrease(args) {
    return "".concat(args.fieldLabel, " verlagen");
  },
  "increase": function increase(args) {
    return "".concat(args.fieldLabel, " verhogen");
  },
  "numberField": "Getalveld"
};
export { $353f1bfca4dc395a$exports as default };